import { registerConfigurationAction } from '../config/registerClientConfig';
import { HpDispatchFunction } from '../types';
import { fetchResolver } from './fetchResolver';
import { HpGetFeatureToggleAction, HpGetFeatureToggleActionPayload } from './getFeatureToggleStateActionTypes';

let websiteEndpoint: string;

registerConfigurationAction((config) => {
  ({ websiteEndpoint } = config);
});

export function getFeatureToggleStateSuccess(payload: HpGetFeatureToggleActionPayload): HpGetFeatureToggleAction {
  return { type: 'RETRIEVED_FEATURE_TOGGLE_STATE', payload };
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function getFeatureToggleStateAction({ featureName }: { featureName: string }): Function {
  return (dispatch: HpDispatchFunction<HpGetFeatureToggleActionPayload>): Promise<void> => {
    const url = `${websiteEndpoint}/api/featureToggle/${encodeURIComponent(featureName)}`;
    return fetchResolver({
      options: { url, method: 'GET', description: `Get feature toggle for "${featureName}"` },
      dispatch,
      successAction: (payload) => {
        dispatch(getFeatureToggleStateSuccess(payload));
      }
    });
  };
}
